'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (secs) {
    var days = Math.floor(secs / 60 / 60 / 24);
    var hours = Math.floor(secs % (60 * 60 * 24) / (60 * 60));
    var minutes = Math.floor(secs % (60 * 60) / 60);
    var seconds = Math.floor(secs % 60);
    return (days > 0 ? days + ' day(s)' : '') + (hours > 0 ? hours + ' hour(s)' : '') + (minutes > 0 ? minutes + ' minute(s)' : '') + (seconds > 0 ? seconds + ' second(s)' : '');
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/secondsToTimeString.js
// module id = 71
// module chunks = 0